'use strict';

function _interopDefault (ex) { return (ex && (typeof ex === 'object') && 'default' in ex) ? ex['default'] : ex; }

var React = require('react');
var React__default = _interopDefault(React);
var tslib = require('tslib');
var HorizontalTab = require('../HorizontalTab/HorizontalTab.js');
var HorizontalTabViews = require('../HorizontalTabViews/HorizontalTabViews.js');

var HorizontalTabStateSharer = function (props) {
    var _a = props.initialValue, initialValue = _a === void 0 ? 0 : _a, onTabChange = props.onTabChange;
    var _b = React.useState(initialValue), passValue = _b[0], setPassValue = _b[1];
    var handleChange = function (value) {
        setPassValue(value);
        if (onTabChange) {
            onTabChange(value);
        }
    };
    var reporter = function (event, value) { return handleChange(value); };
    return {
        HorizontalTabs: function (_a) {
            var labels = _a.labels, rest = tslib.__rest(_a, ["labels"]);
            return (
            // eslint-disable-next-line react/jsx-props-no-spreading
            React__default.createElement(HorizontalTab, tslib.__assign({ reporter: reporter, value: passValue, labels: labels }, rest)));
        },
        HorizontalTabViews: function (_a) {
            var elements = _a.elements;
            return (React__default.createElement(HorizontalTabViews, { value: passValue, elements: elements }));
        },
        updateTabIndex: function (index) {
            // eslint-disable-next-line no-console
            console.warn('Deprecation: updateTabIndex() has been deprecated, have a look at HorizontalTab stories for an alternative');
            handleChange(index);
        },
    };
};

module.exports = HorizontalTabStateSharer;
